import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_APP_",
  client: {
    VITE_APP_BACKEND_URL: z.string().url(),
    VITE_APP_ENVIRONMENT: z.enum(["development", "staging", "production"]),
    VITE_APP_FUNNEL_URL: z.string().url(),
    VITE_APP_GRAPHQL_ENDPOINT: z.string().url(),
    VITE_APP_GRAPHQL_WS_ENDPOINT: z.string().url(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
